import useGameStore from '../store/gameStore';

/**
 * Hotseat "Pass the Device" interstitial: shown when the next active player is a
 * human — blocks all board interaction until they acknowledge the controls.
 */
const HandoverScreen = () => {
  const store = useGameStore();
  const { handover, players } = store;
  if (!handover) return null;
  const player = players.find((p) => p.id === handover.playerId);
  if (!player) return null;
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/95 p-4 backdrop-blur-sm">
      <div
        className="w-full max-w-lg overflow-hidden rounded-3xl border-4 shadow-[0_0_80px_rgba(0,0,0,0.8)]"
        style={{ borderColor: player.color }}
      >
        <div className="px-6 py-5" style={{ backgroundColor: player.color }}>
          <p className="text-[11px] font-black uppercase tracking-[0.25em] text-slate-950/80">Pass the device</p>
          <h2 className="mt-1 text-2xl font-black text-slate-950">Next up: {player.name}</h2>
        </div>
        <div className="bg-slate-900 p-6">
          <div className="flex items-center gap-3">
            <span
              className="flex h-12 w-12 items-center justify-center rounded-full text-sm font-black text-slate-950"
              style={{ backgroundColor: player.color }}
            >
              {player.name.slice(0, 2).toUpperCase()}
            </span>
            <div>
              <p className="text-sm font-extrabold text-white">{player.isAI ? '' : 'You have the controls'}</p>
              <p className="text-xs text-slate-400">Everyone else — hands off the mouse until this turn ends.</p>
            </div>
          </div>
          {handover.summary.length > 0 && (
            <div className="mt-4 rounded-xl border border-slate-700/60 bg-slate-950/70 p-3">
              <p className="text-[10px] font-black uppercase tracking-widest text-slate-500">While you waited…</p>
              <ul className="mt-1.5 max-h-40 space-y-1 overflow-y-auto text-[11px] text-slate-300">
                {handover.summary.map((line, i) => (
                  <li key={i} className="flex gap-1.5"><span className="text-slate-600">·</span><span>{line}</span></li>
                ))}
              </ul>
            </div>
          )}
          <button
            onClick={() => store.beginHandoverTurn()}
            className="mt-5 min-h-[64px] w-full rounded-2xl bg-gradient-to-r from-emerald-400 to-teal-400 px-6 py-4 text-lg font-black text-slate-950 shadow-[0_6px_30px_rgba(52,211,153,0.4)] transition hover:from-emerald-300 hover:to-teal-300"
          >
            I'm Ready — Start My Turn
          </button>
        </div>
      </div>
    </div>
  );
};

export default HandoverScreen;